import React, { useContext } from 'react'
import { CheckSquare, Square } from 'react-bootstrap-icons'
import DateTimePickerFunctions from '../../../../../components/ui/calendar/date_picket/DateTimePickerComponents/DateTimePickerFunctions'
import { UserManagementContext } from '../UserManagementScreen'

export default function TasksSection() {
    const { state, RunTask } = useContext(UserManagementContext)

    return <div className='text-center'>
        <h3>Tasks</h3>
        <div className='mx-3'>
            {state.tasks && state.tasks.tasks && state.tasks.tasks.map((t) =>
                <div className='d-flex' style={{ fontSize: '125%' }} key={t.id}>
                    <div className='d-flex align-items-center'>
                        {t.triggerHistory ? t.triggerHistory.length > 0 ? <CheckSquare /> : <Square /> : 0}
                    </div>
                    <button className='flex-grow-1 text-start btn' onClick={() => RunTask(t.id)}>{t.taskName}</button>
                    <div className='flex-grow-1 small text-dark'>
                        {t.triggerHistory && t.triggerHistory.length > 0 ? `Last ran on ${DateTimePickerFunctions.LocalISO(new Date(t.triggerHistory[t.triggerHistory.length - 1].triggeredDate), 'h')} ${t.triggerHistory[t.triggerHistory.length - 1] ? `by ${t.triggerHistory[t.triggerHistory.length - 1].triggeredBy.firstName} ${t.triggerHistory[t.triggerHistory.length - 1].triggeredBy.lastName}` : ''}` : 'Has not been completed'}
                    </div>
                </div>
            )
            }
        </div>
    </div>
}
